import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SchemaLevel } from '../../config/modules.config';

@Component({
  selector: 'app-schema-display',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './schema-display.component.html',
  styleUrls: ['./schema-display.component.scss']
})
export class SchemaDisplayComponent {
  @Input() schema: SchemaLevel[] = [];

  showArrow(index: number): boolean {
    return index > 0 && !this.schema[index - 1].italic;
  }
}
